import { equal } from "mathjs";
import { CellValue } from "react-table";
import { Subscription, SubscriptionItem } from "../types/subscriptionTypes";

function calculateByQuantity(item: SubscriptionItem, quantity: number, tax: number): void {
  if (+item.quantity <= 0) {
    item.price = 0;
    item.tax_amount = 0;
    item.row_total = 0;
    return;
  }
  if (item && item.price !== undefined && item.quantity !== undefined) {
    const unitPrice = item.price / item.quantity;
    const newPrice = unitPrice * quantity;

    item.price = +newPrice.toFixed(2);
    item.tax_amount = +(item.price * tax).toFixed(2);
    item.row_total = +(item.price + item.tax_amount).toFixed(2);
    item.is_calculation_error = !equal(unitPrice, parseFloat(unitPrice.toFixed(2)));
  }
}

function calculateByPrice(item: SubscriptionItem, price: string, tax: number): void {
  const newPrice = parseFloat(price);

  item.price = newPrice;
  item.tax_amount = +(newPrice * tax).toFixed(2);
  item.row_total = +(newPrice + item.tax_amount).toFixed(2);

  const unitPrice = newPrice / item.quantity;
  item.is_calculation_error = !equal(unitPrice, parseFloat(unitPrice.toFixed(2)));
}

export default function calculate(
  subscription: Subscription,
  details: SubscriptionItem[],
  index: number,
  key: string,
  value: CellValue
): void {
  const item = details[index];
  const tax = subscription.taxRate ? +subscription.taxRate : item.tax_amount / item.price;

  if (key === "quantity") {
    calculateByQuantity(item, value || 1, tax || 0);
  }
  if (key.includes("price")) {
    calculateByPrice(item, Number.isNaN(Number(value)) ? 0 : value, tax);
  }
  subscription.taxAmount = details
    .reduce((prev: number, cur: SubscriptionItem) => Number(prev) + Number(cur.tax_amount || 0), 0)
    .toFixed(2);
  subscription.amount = details
    .reduce((prev: number, cur: SubscriptionItem) => Number(prev) + Number(cur.price || 0), 0)
    .toFixed(2);
  subscription.totalPrice = details
    .reduce((prev: number, cur: SubscriptionItem) => prev + Number(cur.row_total || 0), 0)
    .toFixed(2);
}
